export default __webpack_public_path__ + "static/media/009-flag.1a7761c2.png";